module.exports = __webpack_public_path__ + "static/media/spaceBackgroundCompressed.41da4be0.jpg";